import { getImagePreloadCandidates } from "../components/imageMeta";

export const CHECKOUT_HERO_IMAGE_URL = "/sehaj/Imagery/hero-welcome-two-sikhs%20talking.png";

export const CHECKOUT_FEATURE_IMAGE_URLS = {
  dailyDrops: "/sehaj/paywall/daily-rhythm.webp",
  curiosityHabit: "/sehaj/paywall/gentle-reminder.webp",
  personalized: "/sehaj/paywall/practice-real-life.webp",
  rewarding: "/sehaj/paywall/reflection-progress.webp"
} as const;

const CHECKOUT_APP_SCREENSHOT_URLS = [
  "/sehaj/app-screenshots/01-home.webp",
  "/sehaj/app-screenshots/02-saakhi.webp",
  "/sehaj/app-screenshots/03-listen.webp",
  "/sehaj/app-screenshots/04-reflection.webp",
  "/sehaj/app-screenshots/05-journey.webp",
] as const;

const CHECKOUT_IMAGE_URLS = [
  CHECKOUT_HERO_IMAGE_URL,
  ...Object.values(CHECKOUT_FEATURE_IMAGE_URLS),
  ...CHECKOUT_APP_SCREENSHOT_URLS,
];

export const getCheckoutImagePreloadUrls = (): string[] => {
  const uniqueUrls = new Set<string>();

  for (const imageUrl of CHECKOUT_IMAGE_URLS) {
    const candidates = getImagePreloadCandidates(imageUrl);
    for (const candidate of candidates) {
      uniqueUrls.add(candidate);
    }
  }

  return Array.from(uniqueUrls);
};
